import { useEffect, useState } from "react";

/** Thin gold bar pinned to the top that fills as the reader scrolls the page. */
export default function ReadingProgress() {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      setPct(max > 0 ? Math.min(100, (h.scrollTop / max) * 100) : 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div className="fixed top-0 left-0 right-0 z-[60] h-0.5" data-testid="reading-progress">
      <div className="h-full bg-gold" style={{ width: `${pct}%` }} />
    </div>
  );
}
